import * as Hash from 'object-hash';

export function hashString(value: string): string {
  return Hash(value);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
export function hashObject(value: any): string {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const options: any = { ignoreUnknown: true };
  return Hash(value, options);
}

export function hashFile(file: File): string {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const fileAttributes: any = {
    name: file.name,
    size: file.size,
    type: file.type,
    lastModified: file.lastModified,
  };

  return hashObject(fileAttributes);
}
